<template>
    <div class="home">
        <div class="home-inner">

            <sidebar-trims v-if="isTrimsFolder" />
            <sidebar v-else />

            <product-list />

        </div>
    </div>
</template>

<script>
import ProductList from '@/views/Private/Pages/ProductList'
import Sidebar from '@/views/Private/Components/Sidebar'
import SidebarTrims from '@/views/Private/Components/SidebarTrims'

export default {
  name: 'Home',
  components: {
    SidebarTrims,
    ProductList,
    Sidebar
  },
  computed: {
    isTrimsFolder: function () {
      return this.$store.state.assetQuery.path === '::EC2AMAZ-6RO630I:Trims'
    }
  },
  metaInfo () {
    return {
      title: 'Home'
    }
  }
}
</script>
